// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import { UnorderedList } from "@insite/mobius/Lists";
import Typography from "@insite/mobius/Typography";
import React from "react";

export interface StoreAddToCartRestrictionsMessageProps {
    list: Array<string>;
    isAll?: boolean;
}

const StoreAddToCartRestrictionsMessage: React.FC<StoreAddToCartRestrictionsMessageProps> = ({ list, isAll }) => {
    if (isAll) {
        return (
            <Typography variant="p">
                {translate("All items are restricted and cannot be added to the cart.")}
            </Typography>
        );
    }

    return (
        <>
            <Typography variant="p">
                {translate("The following items will not be added to the cart because of their restrictions")}
                {translate(":")}
            </Typography>
            <UnorderedList>
                {list.map((x, i) => {
                    const key = `${x}.${i}`;
                    return <li key={key}>{x}</li>;
                })}
            </UnorderedList>
        </>
    );
};

export default StoreAddToCartRestrictionsMessage;
